<template>
  <div class="share-popup">
    <CloseButton @close="close" ref="closeButton" />
    <h4 v-if="shoppinglist">Merkliste jetzt teilen</h4>
    <h4 v-else>Teile jetzt dieses Produkt</h4>
    <label :aria-label="`Teile oder kopiere den Link zu ${sharepage ? 'dieser' : 'deiner'} Merkliste`" for="link" v-if="shoppinglist">
      Teile oder kopiere den Link zu
      <span v-if="sharepage">dieser</span
      ><span v-else>
        deiner
      </span>
      Merkliste:
    </label>
    <label for="link" v-else>
      Link zum Produkt:
    </label>
    <textarea class="input" readonly="true" style="resize: none">{{ shareUrl }}</textarea>
    <input type="text" :value="shareUrl" ref="linkInput" readonly="true" aria-hidden="true" tabindex="-1">
    <button
      class="button-primary focus"
      ref="linkButton"
      v-on:click.prevent="copyToClipboard"
      :aria-label="`Link kopieren für ${sharepage ? 'diese' : 'deine'} Merkliste`"
    >
      <span v-if="!copied">Link kopieren</span
      ><i v-if="copied" class="icon-check"></i>
    </button>
    <a
      :href="`whatsapp://send?text=${copyHeadline} ${copyShare} ${shareUrl}`"
      class="button-light mobile"
      :aria-label="`Mit WhatsApp teilen für ${sharepage ? 'diese' : 'deine'} Merkliste`"
    >
      Mit WhatsApp teilen <i class="icon-whatsapp" aria-hidden="true"></i>
    </a>
    <a
      :href="
        `mailto:?subject=${copyHeadline.replace(
          '&',
          '%26'
        )}&body=${copyShare}%0D%0A%0D%0A${shareUrl}`
      "
      class="button-light"
    >
      Via E-Mail teilen <i class="icon-email" aria-hidden="true"></i>
    </a>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CloseButton from "@/components/CloseButton.vue";
export default {
  name: "share-popup",
  components: {
    CloseButton
  },
  props: {
    shareUrl: {
      type: String,
      required: false,
      default: false
    },
    product: {
      type: Object,
      required: false
    },
    shoppinglist: {
      type: Boolean,
      required: false,
      default: true
    },
    sharepage: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      copied: false,
      copyHeadline:
        this.sharepage || this.shoppinglist
          ? "Ich habe für dich eine persönliche Merkliste mit Feuerwerksartikeln erstellt."
          : encodeURI(
              `Ich möchte dir dieses Feuerwerksprodukt bei REWE empfehlen: ${this.product.title}.`
            ),
      copyShare:
        this.sharepage || this.shoppinglist
          ? this.$l("socialShareCopyDefault")
          : this.$l("socialShareCopyProduct")
    };
  },
  mounted() {
    this.$refs.closeButton && this.$refs.closeButton.$el.focus();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    copyToClipboard() {
      const $input = this.$refs.linkInput;
      const $button = this.$refs.linkButton;
      $input.focus();
      $input.select();
      document.execCommand("copy");
      this.copied = true;
      $button.focus();
      window.setTimeout(() => {
        this.copied = false;
      }, 3000);
    }
  }
};
</script>

<style lang="scss">
@import "./SharePopup";
</style>
